import { render, staticRenderFns } from "./BasketPricesRow.vue?vue&type=template&id=70246061&"
import script from "./BasketPricesRow.vue?vue&type=script&lang=js&"
export * from "./BasketPricesRow.vue?vue&type=script&lang=js&"
import style0 from "./BasketPricesRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports